import { useEffect } from 'react';
import ConfigureSection from '../configuration-section';
import ResetSection from '../reset-between-sets';
import { exercisesStats } from '../../../reducers/exercises-reducer';
import 'twin.macro';

const RestUiSection = ({
  isRestStage,
  exerciseType,
  postPerformance,
  handlers,
  state,
  time,
  timerControl,
  isComingUp,
  initialConfig,
  setResult,
  onExit,
  exerciseSummary,
  sendJsonMessage,
  showFormQuality = true,
}) => {
  const Reps = setResult?.reps;
  const NumOfSets = setResult?.sets;
  const accuracy = setResult?.score;
  const excesiceName = setResult?.exerciseName;
  const rest = Number(initialConfig?.settings?.rest);
  const { dispatch } = handlers || {};

  useEffect(() => {
    if (isRestStage) {
      dispatch({
        type: exercisesStats.currentSet,
        payload: state.currentSet + 1,
      });
    }
  }, [isRestStage]);

  return (
    <>
      {(isRestStage || isComingUp) && (
        <div tw="fixed inset-0 z-[100] h-full w-full overflow-hidden">
          {isComingUp && (
            <div tw="h-full w-full">
              <ConfigureSection
                currentTime={time}
                summary={exerciseSummary}
                showFormQuality={showFormQuality}
              />
            </div>
          )}

          {isRestStage && (
            <div tw="h-full w-full">
              <ResetSection
                percentage={accuracy}
                currentSet={setResult?.currentSet}
                dispatch={dispatch}
                exerciseType={exerciseType}
                posPerformance={postPerformance}
                NumOfSets={NumOfSets}
                timer={time}
                restInterval={setResult?.restInterval}
                rest={rest}
                duration={setResult?.duration}
                excesiceName={excesiceName}
                reps={Reps}
                sendJsonMessage={sendJsonMessage}
                timerControl={timerControl}
                onExit={onExit}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default RestUiSection;
